import Swiper, { Navigation, Pagination, EffectFade } from 'swiper';

Swiper.use([Navigation, Pagination, EffectFade]);

var heroSlideshow = new Swiper(".hero-slideshow", {
    effect: 'fade',
	pagination: {
        el: ".swiper-pagination",
        clickable: true,
	},

	// Navigation arrows
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},

	a11y: {
		prevSlideMessage: "Previous slide",
		nextSlideMessage: "Next slide",
    },
    
});
